module.exports = __webpack_public_path__ + "static/media/bg.9e63a624.jpg";